import React from 'react';
import { Button, MinusIcon, PlusIcon } from '@sharefiledev/flow-web';
import { t } from '../../../../utils';
import {
	StyledIconButton,
	StyledText,
	ZoomControlsContainer,
} from './ZoomControls.styled';

export interface Props {
	zoomFactor: number;
	onZoomIn(): void;
	onZoomOut(): void;
}

export const ZoomControls = (props: Props) => {
	return (
		<ZoomControlsContainer>
			<StyledIconButton>
				<Button.IconOnly
					icon={MinusIcon}
					size={12}
					data-testid="doc-zoom-out"
					title={t('zoomOut')}
					onClick={props.onZoomOut}
				/>
			</StyledIconButton>
			<StyledText>{`${Math.round(props.zoomFactor * 100)}%`}</StyledText>
			<StyledIconButton>
				<Button.IconOnly
					icon={PlusIcon}
					size={12}
					data-testid="doc-zoom-in"
					title={t('zoomIn')}
					onClick={props.onZoomIn}
				/>
			</StyledIconButton>
		</ZoomControlsContainer>
	);
};
